showError('') ;
   
  function showError(error) { 
      

    var currentTime
    
    //console.log("natan test") 1714347000000 1714524300000

    
    // Set Custom Shabbat times https://www.epochconverter.com/ //
    var customShabbatStart = 0
    var customShabbatEnd = 0
    // Set custom Shabbat times above //

    //Set Custom CountDown Timer here https://www.epochconverter.com///
    var customCountDownTime = 0


    //force site to be in shabbat mode disregards times//
    var forceOverRide = false
    //True for shabbate Flase for normal function//
    
    $.getJSON('https://api.ipgeolocation.io/ipgeo?apiKey=918995e101b14756bc9b4bf5897bd534', function(data) {
      setCookie("usr_lng", data.longitude, 10); 
      setCookie("usr_ltd", data.latitude, 10); 
      setCookie("usr_tmz", data.time_zone.name, 10); 
      currentTime = data.time_zone.current_time_unix * 1000;
      
      var usr_lng = getCookie("usr_lng");
      var usr_ltd = getCookie("usr_ltd");
      var usr_tmz = getCookie("usr_tmz");

      if (usr_lng != "" && usr_ltd != "" && usr_tmz != "" )  { 
        $.getJSON('https://www.hebcal.com/shabbat/?cfg=json&geo=pos&b=18&latitude='+usr_ltd+'&longitude='+usr_lng+'&tzid='+usr_tmz+'', function(data) {
          separateData(data);
        });
      } else {
        $.getJSON('https://api.ipgeolocation.io/ipgeo?apiKey=918995e101b14756bc9b4bf5897bd534', function(data) {
          //console.log(JSON.stringify(data, null, 2));
          setCookie("usr_lng", data.longitude, 10); 
          setCookie("usr_ltd", data.latitude, 10); 
          setCookie("usr_tmz", data.time_zone.name, 10); 
        });
        $.getJSON('https://www.hebcal.com/shabbat/?cfg=json&geo=pos&b=18&latitude='+data.latitude+'&longitude='+data.longitude+'&tzid='+data.time_zone.name+'', function(data) {
          separateData(data);
        });
      }
    });    
    
    var customTimeYes = false;
    
    function onShabbatPage(){
      if(window.location.href.indexOf("shabbat") > -1) {
        return true;
      }
    };    
    
    function countDownTimer( etime , ctime){
      // Set the date we're counting down to
      var countDownDate = etime.getTime();
      // Set the custom date we're counting down to
      var customCountDown = ctime;

      if( customCountDown > countDownDate ) {
        countDownDate = customCountDown;
      }
      // Update the count down every 1 second
      var x = setInterval(function() {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // Output the result in an element with id="demo"
        document.getElementById("timer").innerHTML = days + "d " + hours + "h "
        + minutes + "m " + seconds + "s ";
      }, 1000)    
    }  

    function separateData(data){
      var shabbat = data.items.filter(function( obj ) {
        return obj.category == 'candles';
      });

      var havdalah= data.items.filter(function( obj ) {
        return obj.category == 'havdalah';
      });

      if(shabbat[0]){
        var startTime = new Date(shabbat[0].date);
      }
      else{
        var startTime = new Date();
      }

      var endTime = new Date(havdalah[0].date);
      setCookie('havdalahDate',endTime.toString(),5);
		
      console.log(data)
      if( currentTime == null ) {
        currentTime = (new Date()).getTime();
      }		
      if( (startTime.getTime() < customShabbatStart) && (customShabbatStart == 0)) {
        customTimeYes = true;
      }
      if(onShabbatPage()){
        countDownTimer( endTime , customCountDownTime);
        console.log(data);
        goHome(currentTime, startTime, endTime);
      } else {
        goShabbatPage(currentTime, startTime, endTime);
      }      
    }

    function goShabbatPage( timeNow, timeStart, timeEnd )  ///delete these curcly brackets
    {
      if(forceOverRide == true) {
        location.assign('https://'+window.location.hostname+'/pages/shabbat');
      }
      if( ( customShabbatStart <= timeNow ) && ( customShabbatEnd > timeNow )){
        location.assign('https://'+window.location.hostname+'/pages/shabbat');
      }                
      
      if( (timeStart.getTime() <= timeNow ) && ( timeEnd.getTime()  > timeNow )){
        location.assign('https://'+window.location.hostname+'/pages/shabbat');
      }
      
      if (timeStart.getTime() > timeEnd.getTime()) {
        if( timeEnd.getTime()  > timeNow ){
          location.assign('https://'+window.location.hostname+'/pages/shabbat');
        } 
      }
    }
     
    function goHome( timeNow, timeStart, timeEnd ) {
      if(forceOverRide == true) {
        return
      }
      if (Shopify.designMode) {
        return    
      }  
      if ( self !== top ) {
        return
      }
      if(window.location.hash) {
        var hash = window.location.hash.substring(1); 
        if(hash == "check") {
          return;
        }
      }     
      if( customTimeYes && (customShabbatStart <= timeNow) && ( customShabbatEnd  < timeNow)){
        location.assign('https://'+window.location.hostname+'/'); 
      }       
      if( (timeStart.getTime() <= timeNow) && ( timeEnd.getTime()  < timeNow)){
        location.assign('https://'+window.location.hostname+'/'); 
      }
      if( (timeStart.getTime() >= timeNow) && ( timeEnd.getTime()  > timeNow)){
        if( customShabbatEnd  > timeNow ){ 
        	return;
        } else {
          	location.assign('https://'+window.location.hostname+'/'); 
        }        
      } 
      return;
    } 

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
              
  function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
};